import React from 'react'
import { ReferenciaCabecera } from '../../../interfaces/ReferenciaCabecera';
// import Author from '../author/author';
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
// import { adapterAuthor } from "../../templates/library-components/adapters";

import "./EditionHeader.scss"

const EditionHeader = (props:ReferenciaCabecera) => {
    const compClass = "m-editionHeader";
  return (
    <div className={`${compClass}`}>
      <div className={`${compClass}__top`}>
        <div className={`${compClass}__top-breadcrumb`}>
        <Breadcrumb content={props.migaDePan} />
        </div>
        <div className={`${compClass}__top-banner`}>
          <div className={`${compClass}__top-image`}>
            <img src={data.imagenHeader.file.url} alt="" />
          </div>
          <div className={`${compClass}__top-content`}>
            <div className={`${compClass}__top-title`}>
              <h1>
                {data.tituloPrincipal}
              </h1>
            </div>
            <h3>{data.tituloSpan}</h3>
            {/* <Author {...adapterAuthor(data.referenciaAutor)} /> */}
            <div className={`${compClass}__top-share`}>
              <p>Compartir</p>
            </div>
          </div>
        </div>
      </div>

      <div className={`${compClass}__interactions`}>
        <div className={`${compClass}__interactions-likes`}>
          <p>10 Me gusta</p>
        </div>
        <div className={`${compClass}__interactions-comments`}>
          <p>Comentar</p>
        </div>
      </div>
    </div>
  )
}

export default EditionHeader
